<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Laporan Hutang</h4>
                        <div class="form-inline">
                          <span><b>Company:</b></span>
                          <select v-model="company_no" class="form-control">
                            <option value="">-- All --</option>
                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                          </select>
                          <span><b>Date:</b></span>
                          <datetime v-model="date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                          <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect" @click="refreshList">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                          </button>
                          <button type="button" class="btn btn-sm btn-soft-primary" @click="process">Process</button>
                          <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-print" aria-hidden="true"></i> Print
                          </button>
                          <div class="dropdown-menu" aria-labelledby="print">
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Outstanding</span></h5>
                <h3 class="my-3">
                  <span>{{ totalOutstanding + totalOutstandingOther | currency }}</span>
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Delivery Cost</span></h5>
                <h3 class="my-3">
                  <span>{{ totalDeliveryCost | currency }}</span>
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Hutang Dagang</span></h5>
                <h3 class="my-3">
                  <span>{{ totalOustandingDagang | currency }}</span>
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-warning">Not Approve</span></h5>
                <h3 class="my-3">
                  <span>{{ notApprove }}</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs nav-bordered">
                            <li class="nav-item"><a href="#hutang-raw" data-toggle="tab" aria-expanded="false" class="nav-link active">Hutang ({{ totalOutstanding | currency }})</a></li>
                            <li class="nav-item"><a href="#hutang-lain-raw" data-toggle="tab" aria-expanded="false" class="nav-link">Hutang Lain-lain ({{ totalOutstandingOther | currency }})</a></li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="hutang-raw">
                                <div class="table-responsive">
                                    <div class="form-group pull-right">
                                      <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                                    </div>
                                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                                        <thead>
                                            <th>No</th>
                                            <th>Purchasing No</th>
                                            <th>Status</th>
                                            <th>Date</th>
                                            <th>Jadwal Bayar</th>
                                            <th>Vendor</th>
                                            <th class="text-right">Delivery Cost</th>
                                            <th class="text-right">Total</th>
                                            <th class="text-right">Retur</th>
                                            <th class="text-right">Payment</th>
                                            <th class="text-right">Outstanding</th>
                                            <th class="text-center">Jatuh Tempo</th>
                                            <th>Tempo</th>
                                            <th>Keterangan</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="d in filterData" :key="d.id">
                                                <td>{{ d.no }}</td>
                                                <td>
                                                  <span class="text-ref-sales" @click="showPurchasingNo(d.purchasing_no)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">
                                                    <b>{{ d.purchasing_no }}</b>
                                                  </span>
                                                </td>
                                                <td>
                                                  <span class="badge badge-primary" v-if="d.status === 'order'">{{ d.status }}</span>
                                                  <span class="badge badge-danger" v-else-if="d.status === 'void'">{{ d.status }}</span>
                                                  <span class="badge badge-success" v-else-if="d.status === 'approve'">{{ d.status }}</span>
                                                  <span class="badge badge-warning" v-else>{{ d.status }}</span>
                                                </td>
                                                <td>{{ d.purchasing_date | dateFormat('DD/MM/YYYY') }}</td>
                                                <td>{{ d.schedule_payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                                <td>{{ d.vendor }}</td>
                                                <td class="text-right">{{ d.delivery_cost | currency }}</td>
                                                <td class="text-right">{{ d.total | currency }}</td>
                                                <td class="text-right">{{ d.retur | currency }}</td>
                                                <td class="text-right">{{ d.payment_balance | currency }}</td>
                                                <td class="text-right">{{ d.outstanding | currency }}</td>
                                                <td>{{ d.purchasing_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                                <td class="text-center">{{ d.age | currency }}</td>
                                                <td>{{ d.notes }}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                          <tr>
                                            <td colspan="12">&nbsp;</td>
                                          </tr>
                                          <tr>
                                            <td colspan="8" class="text-right"><i class="font-16">Total Outstanding:</i></td>
                                            <td class="text-right"><i class="font-16">{{ totalOutstanding | currency }}</i></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                          </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <div class="tab-pane" id="hutang-lain-raw">
                              <div class="table-responsive">
                                <h5 style="margin-top: 25px" class="text-center"><b>Group</b></h5>
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Vendor</th>
                                    <th>Account</th>
                                    <th>Date</th>
                                    <th class="text-right">Debit</th>
                                    <th>Date</th>
                                    <th class="text-right">Credit</th>
                                    <th class="text-right">Outstanding</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="d in dataGroup" :key="d.contact_no">
                                      <td>{{ d.contact_no }} - {{ d.contact }}</td>
                                      <td><b>[{{ d.account_code }}]</b> {{ d.account }}</td>
                                      <td>{{ d.date2 | dateFormat('DD/MM/YYYY') }}</td>
                                      <td class="text-right">{{ d.debit | currency }}</td>
                                      <td>{{ d.date1 | dateFormat('DD/MM/YYYY') }}</td>
                                      <td class="text-right">{{ d.credit | currency }}</td>
                                      <td class="text-right">
                                        <span v-if="d.outstanding > 0" style="text-decoration: line-through;">{{ d.outstanding | currency }}</span>
                                        <span v-else>{{ d.outstanding | currency }}</span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <hr>
                                <h5 style="margin-top: 25px" class="text-center"><b>Journal</b></h5>
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th></th>
                                    <th>Date</th>
                                    <th>Account</th>
                                    <th>Journal</th>
                                    <th>Remark</th>
                                    <th>Contact</th>
                                    <th>Debit</th>
                                    <th>Credit</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="i in dataRaw2" :key="i.id">
                                      <td>
                                        <label class="form-checkbox">
                                          <input type="checkbox" :value="i.id" v-model="selected"><i class="form-icon"></i>
                                        </label>
                                      </td>
                                      <td>{{ i.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td><b>[{{ i.account_code }}]</b> {{ i.account }}</td>
                                      <td>
                                        <span class="text-ref-sales" @click="showJournal(i.journal_id)" data-toggle="modal" data-target="#modalJournalData" data-backdrop="static" data-keyboard="false">
                                          {{ i.journal_code }}
                                        </span>
                                        <span class="badge badge-success ml-2" v-if="i.status === 'posted'">{{ i.status }}</span>
                                        <span class="badge badge-warning ml-2" v-else>{{ i.status }}</span>
                                      </td>
                                      <td>{{ i.remark }}</td>
                                      <td>{{ i.contact }}</td>
                                      <td>{{ i.debit | currency }}</td>
                                      <td>{{ i.credit | currency }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <!-- <pre>{{ selected }}</pre> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <PurchasingModal />
        <JournalModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { journalUrl, financeUrl, getHeader, purchasingUrl, report2Url } from '../../config'
import PurchasingModal from '@/components/purchasing/PurchasingModal.vue'
import JournalModal from '@/components/journal/JournalModal.vue'

export default {
  name: 'HutangOverdue',
  props: ['scroll'],
  components: {
    Loading,
    PurchasingModal,
    JournalModal
  },
  data () {
    return {
      date: new Date().toISOString(),
      loadingSales: true,
      selected: [],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      typeData: null,
      period: [],
      dataGroup: [],
      dataRaw2: [],
      dataRaw: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getEmployeeList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      authUser: state => state.users.authUser
    }),
    notApprove () {
      let notApprove = 0
      if (this.dataRaw.length > 0) {
        for (let i = 0; i < this.dataRaw.length; i++) {
          if (this.dataRaw[i].status !== 'approve') {
            notApprove += 1
          }
        }
      }
      return notApprove
    },
    totalOustandingDagang () {
      var sum = 0
      sum = (this.totalOutstanding + this.totalOutstandingOther) - this.totalDeliveryCost
      return sum
    },
    totalDeliveryCost () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].delivery_cost)
      }
      return sum
    },
    totalOutstandingOther () {
      var sum = 0
      var array = this.dataGroup
      for (let i = 0; i < array.length; i++) {
        var ots = parseFloat(array[i].outstanding)
        if (ots < 0) {
          sum += Math.abs(ots)
        }
      }
      return sum
    },
    totalOutstanding () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].outstanding)
      }
      return sum
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = [{
        salesman: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData () {
      var col = this.sortColumn
      var ascending = this.ascending
      return this.dataRaw.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    }
  },
  methods: {
    async process () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      var resp = {
        error: false,
        message: null
      }
      for (let i = 0; i < array.length; i++) {
        var idJournal = this.dataRaw2.find(d => d.id === array[i])
        await axios.post(journalUrl + '/posting', { id: idJournal.journal_id }, { headers: getHeader() })
          .then(response => {
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      if (resp.error === false) {
        await this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Success', resp.message, 'success')
      }
    },
    showJournal (id) {
      this.$store.dispatch('getJournal', id)
    },
    showPurchasingNo (no) {
      var payload = {
        purchasing_no: no
      }
      this.$store.commit('SET_PURCHASING_ID', payload)
      this.$store.dispatch('getPurchasingShowByNo', payload)
    },
    async showPaymentNo (id) {
      var payload = {
        id: id
      }
      this.$store.dispatch('getPaymentShow', payload)
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selected = []
      var obj = {
        date: this.date,
        company_no: this.company_no
      }
      var url = purchasingUrl + '/hutang-overdue'
      console.log(url)
      await axios.post(url, obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await axios.post(financeUrl + '/get-hutang-journal', obj, { headers: getHeader() })
        .then(response => {
          this.dataGroup = response.data.data.filter(d => parseFloat(d.outstanding) !== 0)
          this.dataRaw2 = response.data.raw
          for (let i = 0; i < this.dataRaw2.length; i++) {
            if (this.dataRaw2[i].status === 'posted') {
              this.selected.push(this.dataRaw2[i].id)
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async print (type) {
      if (this.notApprove > 0) {
        this.$swal('Error', 'Cek pembelian yang belum diapprove!!!', 'error')
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        date: this.date,
        data: this.dataRaw,
        data2: this.dataGroup,
        data3: this.dataRaw2,
        total: this.totalOutstanding,
        total2: this.totalOutstandingOther
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(report2Url + '/hutang', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
  background-color: #6FB56F;
  color: white;
}
.text-ref-sales {
  color: #28A745;
  cursor: pointer;
}
</style>
